export default "__VITE_ASSET__CxQSgSQY__"